import { useEffect, useRef } from 'react';
import classNames from 'classnames';
import { Dialog } from 'primereact/dialog';
import { IModal } from './Modal.types';
import { CloseIcon } from '@ds-icons';
import styles from './Modal.module.scss';
import { Loader } from '../Loader/Loader';

export const Modal: React.FC<IModal> = (props) => {
  const {
    className = '',
    visible = false,
    onModalClosed,
    children,
    title,
    disableClickOutside = false,
    displayCloseIcon = true,
    position = 'center',
    showLoadingOverlay = false,
    modalClassName = '',
    fullwidth = false,
    fullheight = false,
  } = props;
  const modalRef = useRef<HTMLDivElement>(null);

  const handleClickOutside = (event: MouseEvent) => {
    const dropdownElements = document.querySelectorAll('.p-dropdown-panel, .p-datepicker');
    const isClickInsideDropdown = Array.from(dropdownElements).some((dropdown) =>
      dropdown.contains(event.target as Node)
    );

    if (
      !disableClickOutside &&
      modalRef.current &&
      !modalRef.current.contains(event.target as Node) &&
      !isClickInsideDropdown
    ) {
      onHide();
    }
  };

  const onHide = () => {
    if (onModalClosed) onModalClosed();
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [onHide, disableClickOutside]);

  return (
    <Dialog
      data-testid="modal"
      data-leave-modal-content
      draggable={false}
      visible={visible}
      position={position}
      className={classNames(className, styles['ds-modal'], {
        [styles['p-dialog-exit']]: !visible,
        [styles['fullwidth']]: fullwidth,
        [styles['fullheight']]: fullheight,
      })}
      onHide={onHide}
      focusOnShow={false}
      content={({ hide }) => (
        <div
          className={classNames(
            styles['modal'],
            { [styles['fullwidth']]: fullwidth, [styles['fullheight']]: fullheight },
            modalClassName
          )}
          ref={modalRef}
        >
          {(title || displayCloseIcon) && (
            <div className={styles.header} data-testid="modal-header">
              {typeof title === 'string' ? <h3>{title}</h3> : title}
              {displayCloseIcon && (
                <img data-testid="close-icon" className={styles['close-icon']} src={CloseIcon} onClick={hide} />
              )}
            </div>
          )}

          <div className={styles.content}>{children}</div>
          {showLoadingOverlay && (
            <div className={styles.overlay} data-testid="loading-overlay">
              <Loader />
            </div>
          )}
        </div>
      )}
    />
  );
};
